import { GJ } from "./galleryJustify";

export const GLM = {
    init: () => {
        GLM.initLoadMore();
        GLM.initCarouselSwipe();
    },

    initLoadMore: () => {
        document.querySelectorAll('.gallery-load-more-btn').forEach(btn => {
            btn.addEventListener('click', function () {
                const targetSelector = this.getAttribute('data-target');
                const step = parseInt(this.getAttribute('data-step'), 10) || 3;
                const container = document.querySelector(targetSelector);
                if (!container) return;

                this.classList.add('is-loading');

                setTimeout(() => {
                    const hiddenItems = container.querySelectorAll('.gallery-grid-item.d-none');
                    let shown = 0;

                    hiddenItems.forEach(item => {
                        if (shown < step) {
                            item.classList.remove('d-none');
                            shown++;
                        }
                    });

                    this.classList.remove('is-loading');

                    // Re-justify the mosaic layout once the newly shown images are loaded.
                    if (container.classList.contains('gallery-masonry')) {
                        GJ.setup(container);
                    }

                    const remaining = container.querySelectorAll('.gallery-grid-item.d-none');
                    if (remaining.length === 0) {
                        this.style.display = 'none';
                    }
                }, 400);
            });
        });
    },

    initCarouselSwipe: () => {
        const carousels = document.querySelectorAll('.gallery-slider');

        carousels.forEach(carousel => {
            let startX = 0;
            let endX = 0;
            let isDragging = false;

            const threshold = 40; 

            const handleSwipe = () => {
                const diff = startX - endX;
                if (Math.abs(diff) > threshold) {
                    if (diff > 0) {
                        // Swiped left -> Trigger 'Next'
                        const nextBtn = carousel.querySelector('.carousel-control-next');
                        if (nextBtn) nextBtn.click();
                    } else {
                        // Swiped right -> Trigger 'Previous'
                        const prevBtn = carousel.querySelector('.carousel-control-prev');
                        if (prevBtn) prevBtn.click();
                    }
                }
            };

            carousel.addEventListener('mousedown', (e) => {
                startX = e.clientX;
                endX = startX;
                isDragging = true;
            });

            carousel.addEventListener('mousemove', (e) => {
                if (!isDragging) return;
                endX = e.clientX;
            });

            carousel.addEventListener('mouseup', () => {
                if (!isDragging) return;
                isDragging = false;
                handleSwipe();
            });

            carousel.addEventListener('mouseleave', () => {
                if (isDragging) {
                    isDragging = false;
                    handleSwipe();
                }
            });

            carousel.addEventListener('touchstart', (e) => {
                startX = e.touches[0].clientX;
                endX = startX;
            }, { passive: true });

            carousel.addEventListener('touchmove', (e) => {
                endX = e.touches[0].clientX;
            }, { passive: true });

            carousel.addEventListener('touchend', () => {
                handleSwipe();
            });

            carousel.addEventListener('click', (e) => {
                if (Math.abs(startX - endX) > 10) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, true); 
        });
    }
};